import '../../assets/fontawesome/css/all.min.css';

const SocialMediaLinks = () => {

  return (
    <div className="social-media-links">
      <a
        href="https://open.spotify.com/artist/1gksgycDNzFiSND7NG58Vx"
        className="social-media-link"
      >
        <i className="fab fa-spotify"></i>
      </a>
      <a
        href="https://www.instagram.com/laurimikael_official/"
        className="social-media-link pl-2"
      >
        <i className="fab fa-instagram"></i>
      </a>
      <a
        href="https://www.facebook.com/Lauri-Mikael-113950927065708"
        className="social-media-link pl-2"
      >
        <i className="fab fa-facebook"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCNJoMYQkYbAtrVi8j14-okA"
        className="social-media-link pl-2"
      >
        <i className="fab fa-youtube"></i>
      </a>
    </div>
  );
};

export default SocialMediaLinks;